module.exports = require(16).EventEmitter;
